// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"banner_ko-KR__FZsRu","impressionTrackingContainer":"banner_impressionTrackingContainer__P43iu","banner":"banner_banner__3EbGk"};